import React from 'react';
import { get } from 'lodash';
import searchQuery from 'query-string';
import { withRouter } from 'react-router-dom';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import {memberDetailsSavingsMailPrescriptionWidget as MemberDetailsSavingsMailPrescriptionWidgetView  } from 'ui/views/widgets/memberDetailsSavingsMailPrescriptionWidget';
import { MemberDetailsSavingsMailPrescriptionWidgetService } from 'services/memberDetailsSavingsMailPrescriptionWidget';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import * as backRoute from 'utils/backRoute';
import { overlay } from 'modules/overlay';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsSavingsMailPrescriptionWidget } from 'ui/containers/MemberDetailsSavingsMailPrescriptionWidget';
 *
 * // render
 * <MemberDetailsSavingsMailPrescriptionWidget propName='propValue'/>
 */
class _MemberDetailsSavingsMailPrescriptionWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // bind methods
        this.handleActionClick = this.handleActionClick.bind( this );

        // Member Detail instance
        this.memberDetailsSavingsMailPrescriptionWidgetService = new MemberDetailsSavingsMailPrescriptionWidgetService();

        // start member detail data fetch
        this.memberDetailsSavingsMailPrescriptionWidgetData();
    }

    async memberDetailsSavingsMailPrescriptionWidgetData() {
       
        log.debug( 'MemberDetailsSavingsMailPrescriptionWidgetService.memberDetailsSavingsMailPrescriptionWidgetData()' );

        // cancel ongoing request
        this.memberDetailsSavingsMailPrescriptionWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsSavingsMailPrescriptionWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {}, /*selection = []*/ } = {} ) {
        log.debug( 'MemberDetailsSavingsMailPrescriptionsEntityWidget.handleActionClick()'  );

        // get member id
        const memberId = get( this.props, 'requestPayload.context.memberId', null );

        //const prescriptionId = get( item, 'id', null );

        // prepare back-route state payload
        const backRouteState = backRoute.encode( {
            pathname: this.props.location.pathname,
            payload: {
                entitiesActiveTabIndex: this.props.tabIndex,
                memberId: memberId,
            },
        } );

        if( 'column' === type && 'rxNumber' === value.name ) {
            
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.PRESCRIPTION_DETAIL,
                state: {...backRouteState,  memberId: memberId },
                search: searchQuery.stringify( {
                    rxId: item.values.rxNumber,
                } )
            } );
            overlay.close();
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsSavingsMailPrescriptionWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsSavingsMailPrescriptionWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberDetailsSavingsMailPrescriptionWidget.displayName = 'MemberDetailsSavingsMailPrescriptionWidget';

// set default props
_MemberDetailsSavingsMailPrescriptionWidget.defaultProps = {
    requestPayload: {},
};

// prop types
_MemberDetailsSavingsMailPrescriptionWidget.propTypes = {};

export const MemberDetailsSavingsMailPrescriptionWidget = withRouter( _MemberDetailsSavingsMailPrescriptionWidget );
